export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgIi9hc3NldHMvbG9nby5kMGM5ZmJlMy45NjMzNDM0Yi1mZmRkLTRlNzAtOGY4Yy1mMDk1YzU1ZGZmMjQucG5nIjs="